import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { client, errorValidation } from "./service.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getCategories(query) {
  try {
    let response = await client.get(`/category`, {
      params: {
        merchantId: query?.merchantId || ''
      }
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    console.log('here error', e)
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function getCategory(id) {
  try {
    let response = await client.get(`/category/${id}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function createCategory(body) {
  try {
    let response = await client.post(`/category/create`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function updateCategory(body) {
  try {
    let response = await client.post(`/category/update`, {
      ...body
    });
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

export async function deleteCategory(id) {
  try {
    let response = await client.delete(`/category/delete/${id}`);
    if (response.data.statusCode !== 200) { throw response.data.data; }
    let data = response.data.data;
    return { data };
  } catch (e) {
    // return { error: e.response.data.errorCode }
    return errorValidation(e)
  }
}

// v2
export async function getCategoriesV2({
  merchantId = '', placeId = '', name, page, limit
}) {
  console.log('url : ', `${adminUrl}/category-v2`)
  try {
    let response = await axios.Get({
      url: `${adminUrl}/category-v2`,
      params: {
        merchantId,
        placeId,
        name,
        page,
        limit
      }
    });
    if (response.statusCode !== 200) { return { error: response.message }; }
    return { data: response.data };
  } catch (e) {
    // return { error: e.response.errorCode }
    return { error: e.response.data };
  }
}